import api from '@/api';

export default {
    namespaced: true,
    state: {
        page: 0,
        pagesize: 10,
        count: 0,
        list: [],
    },
    getters: {

    },
    mutations: {
        setPage(state, page) {
            state.page = page;
        },
        setPagesize(state, pagesize) {
            state.pagesize = pagesize;
        },
        setCount(state, count) {
            state.count = count;
        },
        setList(state, list) {
            state.list = list;
        },
    },
    actions: {
        async list(context, { page, start, end }) {
            try {
                const response = await api.logs.list(page, start, end);
                context.commit('setPage', response.data.page);
                context.commit('setPagesize', response.data.pagesize);
                context.commit('setCount', response.data.count);
                context.commit('setList', response.data.changes);
            } catch (err) {
                if (process.env.NODE_ENV !== 'production') {
                    console.log(err);
                }
            }
        },
    },
};
